module.exports = __webpack_public_path__ + "static/media/TheTravelInnovationSummit.a1bde219.jpg";